import { AxiosResponse } from 'axios';

export interface ApiRequestOptions {
  url: string;
  data?: any;
  headers?: Record<string, string>;
  params?: Record<string, any>;
  skipNafHeaders?: boolean; // Skip Authorization and Ocp-Apim-Subscription-Key headers
  withCredentials?: boolean; // Whether to send cookies with the request
  skipPlatformHeader?: boolean; // Whether to skip adding the client platform header
  signal?: AbortSignal;
}

export enum ApiType {
  apimFormApi = 'apimFormApi',
  apimMotorApi = 'apimMotorApi',
  apimNafNoApi = 'apimNafNoApi',
  apimVehicleDataApi = 'apimVehicleDataApi',
  apimMembershipApi = 'apimMembershipApi',
  apimNafCenterApi = 'apimNafCenterApi',
  apimTravelApi = 'apimTravelApi',
  apimMapsApi = 'apimMapsApi',
  elasticSearchAPI = 'elasticSearchAPI',
  external = 'external', // For full URLs that don't need base URL building
}

export interface ApiConfig {
  apimContentHub?: string;
  apimBaseUrl?: string;
  authToken?: string;
  [key: string]: any; // For dynamic API endpoints
}

export type TokenProvider = () => Promise<string | undefined>;

export interface ApiClientInterface {
  get<T = any>(apiType: ApiType, options: ApiRequestOptions): Promise<AxiosResponse<T>>;
  post<T = any>(apiType: ApiType, options: ApiRequestOptions): Promise<AxiosResponse<T>>;
  put<T = any>(apiType: ApiType, options: ApiRequestOptions): Promise<AxiosResponse<T>>;
  delete<T = any>(apiType: ApiType, options: ApiRequestOptions): Promise<AxiosResponse<T>>;
  patch<T = any>(apiType: ApiType, options: ApiRequestOptions): Promise<AxiosResponse<T>>;
  setStore(store: any): void;
  setToken(token: string): void;
  setTokenProvider(provider?: TokenProvider): void;
  clearToken(): void;
  getToken(): string | undefined;
  getCurrentConfig(): ApiConfig;
  destroy(): void;
}
